<input
  #formField
  [id]="id"
  type="text"
  [placeholder]="placeholder"
  [disabled]="isDisabled"
  [value]="displayValue"
  (input)="handleChange({ event: $event, value: $any($event.target).value })" />

